export default __webpack_public_path__ + "static/media/scissors.10acd036.png";